import { onCleanup, onMount, createSignal } from 'solid-js'

import createEmblaCarousel from 'embla-carousel-solid'
import { A, useNavigate } from '@solidjs/router'
import { getAssetUrl } from '/web/shared/util'
import { userStore } from '/web/store'
import BonusTokensButton from '/web/shared/aifans/BonusTokensButton'

const AUTO_SCROLL_INTERVAL = 3000

const HomeSpotlight = () => {
  const HomesContent = [
    {
      realName: 'Candice Nice',
      characterName: 'Harley Quinn',
      altText: 'Candice Nice cosplays as Harley Quinn',
      text: "With her infectious energy and impeccable attention to detail, she brings the iconic character to life in a whirlwind ofcolor and chaos. From her playful demeanor to her penchant formischief, Candice captivates audiences with her boundlessenthusiasm for embodying Gotham's most enigmatic villainess...",
      link: '/model/harley-quinn/candice-nice/',
      bg: getAssetUrl('/assets/home/home-1/bg-harley-quinn.webp', true),
      bgSmall: getAssetUrl('/assets/home/home-1/bg-small-harley-quinn.webp', true),
      bgPosition: 'bg-homePosOne bg-homeSizOne xs:bg-[76%] lg:bg-center',
      nameLogo: getAssetUrl('/assets/home/home-1/logo-harley-quinn-v2.webp', true),
      galleryOne: getAssetUrl('/assets/home/home-1/gallery1-harley-quinn.png', true),
      galleryTwo: getAssetUrl('/assets/home/home-1/gallery2-harley-quinn.png', true),
      nameLogoPosition:
        'pt-5 pb-3 md:py-3 max-w-[150px] md:max-w-[195px] xs:max-w-[55vw] lg:max-w-[400px] left-[75%] bottom-[45%]',
      age: 20,
      country: 'US',
    },
    {
      realName: 'Lexy Quinn',
      characterName: 'Barbie',
      altText: 'Lexy Quinn cosplays as Barbie',
      text: 'Hey everyone, I’m Lexi Quinn, and I love bringing cosplay dreams to life! One of my favorite transformations is becoming Barbie — stylish, confident, and iconic. Whether it’s classic glam or a bold twist, it’s all about fierce, fun femininity. Join me for exclusive VIP content, live chats, and custom-generated images you won’t find anywhere else!....',
      link: '/model/barbie/lexy-quinn/',
      bg: getAssetUrl('/assets/home/home-2/bg-barbie.webp', true),
      bgSmall: getAssetUrl('/assets/home/home-2/bg-small-barbie.webp', true),
      bgPosition: 'bg-homePosTwon bg-homeSizTwo xs:bg-[91.5%_80%] lg:bg-center',
      nameLogo: getAssetUrl('/assets/home/home-2/logo-barbie-v2.webp', true),
      galleryOne: getAssetUrl('/assets/home/home-2/gallery1-barbie.webp', true),
      galleryTwo: getAssetUrl('/assets/home/home-2/gallery2-barbie.webp', true),
      nameLogoPosition:
        'pt-1 md:pt-12 pb-2 md:pb-8 max-w-[150px] md:max-w-[187px] xs:max-w-[55vw] lg:max-w-[340px] left-[69%] bottom-[45%]',
      age: 20,
      country: 'US',
    },
    {
      realName: 'Clara Everly',
      characterName: 'Hermione Granger',
      altText: 'Clara Everly cosplays as Hermione Granger',
      text: 'One of my favorite characters to become is Hermione Granger from Harry Potter-smart, fearless, and full of heart. Stepping into her world lets me channel that iconic wizard energy and bring a touch of magic to life. Join me for access to exclusive VIP content, live chats, and custom generated images on my exclusive fan page!...',
      link: '/model/hermione-granger/clara-everly/',
      bg: getAssetUrl('/assets/home/home-3/bg-hermione.webp', true),
      bgSmall: getAssetUrl('/assets/home/home-3/bg-small-hermione.webp', true),
      bgPosition: 'bg-homePosThree bg-homeSizThree xs:bg-[72%] lg:bg-center',
      nameLogo: getAssetUrl('/assets/home/home-3/logo-hermione.webp', true),
      galleryOne: getAssetUrl('/assets/home/home-3/gallery1-hermione.webp', true),
      galleryTwo: getAssetUrl('/assets/home/home-3/gallery2-hermione.webp', true),
      nameLogoPosition:
        'pt-3 pb-6 md:pt-6 md:pb-20 max-w-[150px] md:max-w-[218px] xs:max-w-[55vw] lg:max-w-[400px] left-[70%] bottom-[35%]',
      age: 18,
      country: 'US',
    },
    {
      realName: 'Julie Rich',
      characterName: 'Wonder Woman',
      altText: 'Julie Rich cosplays as Wonder Woman',
      text: 'One of my favorite characters to become is Wonder Woman—strong, fearless, and fiercely iconic. Stepping into her boots lets me embody that Amazonian power and bring a heroic spark to life. Subscribe to my exclusive fan page and gain access to exclusive VIP content, live chats, and custom-generated images!...',
      link: '/model/wonder-woman/julie-rich/',
      bg: getAssetUrl('/assets/home/home-4/bg-ww.webp', true),
      bgSmall: getAssetUrl('/assets/home/home-4/bg-small-ww.webp', true),
      bgPosition: 'bg-homePosFour bg-homeSizFour xs:bg-[80%] lg:bg-center',
      nameLogo: getAssetUrl('/assets/home/home-4/logo-ww.webp', true),
      galleryOne: getAssetUrl('/assets/home/home-4/gallery1-ww.webp', true),
      galleryTwo: getAssetUrl('/assets/home/home-4/gallery2-ww.webp', true),
      nameLogoPosition:
        'pt-4 pb-8 md:pt-7 md:py-10  max-w-[140px] md:max-w-[215px] lg:max-w-[335px] left-[70%] bottom-[58%]',
      age: 21,
      country: 'US',
    },
    {
      realName: 'Mio Sakai',
      characterName: 'Son Goku',
      altText: 'Mio Sakai cosplays as Son Goku',
      text: 'Hi, I’m Mio Sakai—a passionate cosplayer who loves channeling the unstoppable energy of Son Goku! Whether I’m rocking his classic orange gi or going full Super Saiyan, I bring the power and heart of Dragon Ball to life. Get exclusive content, join live chats, and explore custom-generated images only on my fan page. Let’s level up together!...',
      link: '/model/son-goku/mio-sakai/',
      bg: getAssetUrl('/assets/home/home-5/bg-son-goku.webp', true),
      bgSmall: getAssetUrl('/assets/home/home-5/bg-small-son-goku.webp', true),
      bgPosition: 'bg-homePosFive bg-homeSizFive xs:bg-[81%] lg:bg-center',
      nameLogo: getAssetUrl('/assets/home/home-5/logo-son-goku.webp', true),
      galleryOne: getAssetUrl('/assets/home/home-5/gallery1-son-goku.webp', true),
      galleryTwo: getAssetUrl('/assets/home/home-5/gallery2-son-goku.webp', true),
      nameLogoPosition:
        'pt-6 pb-12 md:pt-6 md:pb-14 max-w-[180px] md:max-w-[218px] xs:max-w-[55vw] lg:max-w-[660px] left-[62%] bottom-[46%]',
      age: 18,
      country: 'JP',
    },
  ]

  const nav = useNavigate()

  const [emblaRef, emblaApi] = createEmblaCarousel(
    () => ({ loop: true, speed: 10, containScroll: 'trimSnaps' })
    // () => [Autoplay({ delay: 2500 })]
  )

  let autoplayInterval: ReturnType<typeof setInterval> | null = null
  const [currentSlide, setCurrentSlide] = createSignal(0)

  // Autoplay function to automatically scroll to the next slide
  const autoplay = () => {
    if (emblaApi()) {
      autoplayInterval = setInterval(() => {
        if (!userStore().showLogin) {
          emblaApi()?.scrollNext()
        }
      }, AUTO_SCROLL_INTERVAL) // Auto-scroll every 3 seconds
    }
  }

  // Reset autoplay timer
  const resetAutoplay = () => {
    if (autoplayInterval) {
      clearInterval(autoplayInterval) // Clear the existing autoplay timer
    }
    autoplay() // Start autoplay again
  }

  onMount(() => {
    autoplay() // Start autoplay when the component mounts
    emblaApi()?.on('pointerDown', resetAutoplay)
    emblaApi()?.on('select', () => {
      setCurrentSlide(emblaApi()?.selectedScrollSnap() || 0)
    })
  })

  onCleanup(() => {
    emblaApi()?.destroy()
  })

  // Handlers for next and previous buttons
  const scrollNext = () => {
    emblaApi()?.scrollNext()
    resetAutoplay()
  }

  const scrollPrev = () => {
    emblaApi()?.scrollPrev()
    resetAutoplay()
  }

  return (
    <main class="home relative">
      <div class="embla">
        <div class="embla__viewport" ref={emblaRef}>
          <div class="embla__container">
            {HomesContent.map((item) => (
              <div
                style={{
                  'background-image': `url(${screen.width < 1024 ? item.bgSmall : item.bg})`,
                }}
                class={`slide embla__slide max-h-[665px]f xs:max-h-nonef h-[calc(100svh-118px)] overflow-hidden !bg-cover bg-no-repeat pb-16 pt-12 xs:pt-32 sm:pb-0 sm:pt-36 md:h-[calc(100svh)] md:min-h-screen md:pt-28 lg:min-h-[971px] ${item.bgPosition}`}
                onClick={() => nav(item.link)}
              >
                {/* Hidden image for SEO */}
                <img
                  src={screen.width < 1024 ? item.bgSmall : item.bg}
                  alt={`${item.realName} cosplaying as ${item.characterName} - Featured creator background`}
                  class="sr-only"
                  aria-hidden="true"
                />
                <div class="container">
                  <div class="wrapper">
                    <div class="content flex flex-col items-start">
                      <div class="top relative flex flex-col items-start leading-none">
                        <h3 class="text-base font-semibold text-cyan [text-shadow:_-1px_-1px_0_rgba(0,0,0,0.25),_1px_-1px_0_rgba(0,0,0,0.25),_-1px_1px_0_rgba(0,0,0,0.25),_1px_1px_0_rgba(0,0,0,0.25)] sm:text-2xl md:text-3xl">
                          FEATURED CREATOR
                        </h3>
                        <h2
                          class={`mt-2 text-[28px] font-bold leading-none [text-shadow:_-1px_-1px_0_rgba(0,0,0,0.25),_1px_-1px_0_rgba(0,0,0,0.25),_-1px_1px_0_rgba(0,0,0,0.25),_1px_1px_0_rgba(0,0,0,0.25)] sm:mt-6 md:text-[56px]`}
                        >
                          {item.realName}{' '}
                          <span class="text-base font-medium xs:text-xl sm:font-bold md:text-[56px]">
                            as
                          </span>
                        </h2>
                        {/* pera */}
                        <div class="pera mt-10 hidden w-full max-w-[37.75rem] text-xl font-medium md:block">
                          {item.text}
                          <A
                            href={item.link}
                            class="read-more cursor-pointer pl-2 text-cosplay-red"
                          >
                            Read More
                          </A>
                        </div>
                        <div class="min-h-16 sm:min-h-[inherit] xl:h-[inherit]">
                          <img
                            class={`sm:h-[inherit] sm:w-full xl:absolute ${item.nameLogoPosition}`}
                            src={item.nameLogo}
                            alt={item.characterName}
                          />
                        </div>
                      </div>

                      {/* middle */}
                      <div class="middle text-lg font-semibold xs:mt-6 sm:text-[22px]">
                        {/* Desktop only - 2x2 flexbox layout */}
                        <div class="hidden sm:flex sm:flex-wrap sm:gap-x-8 sm:gap-y-4">
                          <div>
                            <div class="item mb-6 flex items-center gap-2 sm:gap-4">
                              <img
                                class="h-[26px]"
                                src="/images/icons/flame.svg"
                                alt="Hot flame icon"
                              />
                              <h4>Exclusive VIP Content!</h4>
                            </div>
                            <div class="item flex items-center gap-2 sm:gap-4">
                              <img
                                class="h-[26px]"
                                src="/images/icons/flame.svg"
                                alt="Hot flame icon"
                              />
                              <h4>Image Generation!</h4>
                            </div>
                          </div>
                          <div>
                            <div class="item mb-6 flex items-center gap-2 sm:gap-4">
                              <img
                                class="h-[26px]"
                                src="/images/icons/flame.svg"
                                alt="Hot flame icon"
                              />
                              <h4>Live Chat 24/7!</h4>
                            </div>
                            <div class="item flex items-center gap-2 sm:gap-4">
                              <img
                                class="h-[26px]"
                                src="/images/icons/flame.svg"
                                alt="Hot flame icon"
                              />
                              <h4>Customize your Character!</h4>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* registration btn */}
                      <div class="btn flex md:pt-7">
                        <button
                          class="registration-btn relative hidden h-[56px] w-[175px] items-center justify-center rounded-xl border border-white text-base font-semibold ring-[3px] ring-transparent transition-all duration-300 before:absolute  before:inset-0 before:-z-0 before:rounded-xl before:bg-gradient-to-r before:from-secondary before:to-primary before:transition-all before:duration-300 hover:ring-secondary hover:before:opacity-50 sm:w-[209px] md:flex"
                          onClick={() => nav(item.link)}
                        >
                          <span class="relative">View Profile</span>
                        </button>
                        <BonusTokensButton className="md:hidden" />
                      </div>
                      {/* gallery */}
                      <div class="gallery mt-9 hidden grid-cols-2 gap-9 md:grid">
                        <A href={item.link}>
                          <img
                            class="h-full max-h-[232px] w-full max-w-[350px] rounded-xl"
                            src={getAssetUrl(item.galleryOne, true)}
                            alt={`${item.altText} - Gallery image 1`}
                          />
                        </A>
                        <A href={item.link}>
                          <img
                            class="h-full max-h-[232px] w-full max-w-[350px] rounded-xl"
                            src={getAssetUrl(item.galleryTwo, true)}
                            alt={`${item.altText} - Gallery image 2`}
                          />
                        </A>
                      </div>

                      {/* see profile */}
                      <A
                        href={item.link}
                        class="see-profile hidden items-center gap-1 py-7 text-base text-[#FF0000] sm:flex"
                      >
                        <span> See profile</span>{' '}
                        <svg
                          fill="#FF0000"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"></path>
                        </svg>
                      </A>
                    </div>
                  </div>
                </div>

                {/* Bottom Info Bar */}
                <div class="absolute bottom-0 left-0 right-0 h-9 border-b border-white md:hidden">
                  <div class="container h-full">
                    <div class="wrapper h-full">
                      <div class="flex h-full items-center justify-between">
                        {/* Left: See Profile */}
                        <A
                          href={item.link}
                          class="flex items-center gap-1 text-sm font-normal text-white"
                        >
                          <span>See Profile</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="7"
                            height="11"
                            viewBox="0 0 7 11"
                            fill="none"
                          >
                            <path
                              d="M0.229207 0.202668C0.515717 -0.0506669 0.969114 -0.0665003 1.27648 0.155167L1.33592 0.202668L5.55435 3.93264C6.24197 4.54065 6.26653 5.51292 5.62802 6.14694L5.55435 6.21596L1.33592 9.94594C1.03031 10.2162 0.534817 10.2162 0.229207 9.94594C-0.0573019 9.6926 -0.0752087 9.2917 0.175487 9.01992L0.229207 8.96737L4.44763 5.2374C4.53819 5.15733 4.54825 5.03304 4.47782 4.94315L4.44763 4.91121L0.229207 1.18123C-0.0764025 0.91101 -0.0764025 0.472891 0.229207 0.202668Z"
                              fill="#ffffff"
                            />
                          </svg>
                        </A>

                        {/* Right: Age and Nationality */}
                        <div class="flex items-center gap-2 text-sm font-normal text-white">
                          <span>Age: {item.age}</span>
                          <span>{item.country}</span>
                          <span
                            class={`fi fi-${item.country?.toLowerCase() || 'us'} h-[10px] w-[15px]`}
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Mobile: Dots Navigation */}
      <div class="arrows absolute bottom-4 left-1/2 flex -translate-x-1/2 items-center gap-2 fill-white md:hidden">
        {HomesContent.map((_, index) => (
          <button
            onClick={() => emblaApi()?.scrollTo(index)}
            class={`h-[6px] w-[6px] rounded-full transition-all duration-300 ${
              index === currentSlide() ? 'bg-cosplay-red' : 'bg-white/75'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Desktop: Arrow Navigation */}
      <div class="arrows absolute bottom-10 right-8 hidden items-center gap-4 fill-white md:flex">
        <div
          onClick={scrollPrev}
          class="left embla__prev left-3 top-1/2 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-primary/60 shadow-2xl backdrop-blur-2xl transition-all duration-300 hover:bg-primary md:absolute"
        >
          <svg
            class="h-8 w-8"
            stroke-width="0"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"></path>
          </svg>
        </div>
        <div
          onClick={scrollNext}
          class="right embla__next right-3 top-1/2 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-primary/60 shadow-2xl backdrop-blur-2xl transition-all duration-300 hover:bg-primary md:absolute"
        >
          <svg
            class="h-8 w-8"
            stroke-width="0"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"></path>
          </svg>
        </div>
      </div>
    </main>
  )
}

export default HomeSpotlight
